import { defineStore } from 'pinia'

export const useTagsStore = defineStore('tags', {
  state: () => ({
    tags: [],
    loading: false,
    lastFetched: null,
    cacheTimeout: 30000, // 30 seconds
  }),

  getters: {
    allTags: (state) => state.tags,
    tagsCount: (state) => state.tags.length,
    isLoading: (state) => state.loading,
    isCacheValid(state) {
      if (!state.lastFetched) return false
      return Date.now() - state.lastFetched < state.cacheTimeout
    },
    tagById: (state) => (id) => {
      return state.tags.find(tag => tag.id === parseInt(id))
    },
    totalTriggers(state) {
      return state.tags.reduce((sum, tag) => sum + (tag.events_count || 0), 0)
    },
    averageTriggers(state) {
      if (state.tags.length === 0) return 0
      return Math.round(this.totalTriggers / state.tags.length)
    }
  },

  actions: {
    async fetchTags(force = false) {
      // Use cache if valid and not forced
      if (!force && this.isCacheValid) {
        return this.tags
      }

      this.loading = true
      try {
        const response = await axios.get('/api/tags')
        this.tags = response.data.data
        this.lastFetched = Date.now()
        return this.tags
      } catch (error) {
        console.error('Error fetching tags:', error)
        throw error
      } finally {
        this.loading = false
      }
    },

    invalidateCache() {
      this.lastFetched = null
    },

    // Optional: Optimistic updates
    addTagOptimistic(tag) {
      this.tags.unshift(tag)
    },

    removeTagOptimistic(id) {
      const index = this.tags.findIndex(t => t.id === id)
      if (index !== -1) {
        this.tags.splice(index, 1)
      }
    },

    updateTagOptimistic(id, data) {
      const index = this.tags.findIndex(t => t.id === id)
      if (index !== -1) {
        this.tags[index] = { ...this.tags[index], ...data }
      }
    }
  }
})
